import { selectCurrentHotelId } from 'accessors'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import HotelSetupAddendum from 'features/HotelSetup/Addendum'
import HotelSetupFinalize from 'features/HotelSetup/Finalize'
import HotelSetupHeader from 'features/HotelSetup/Header'
import HotelSetupHotelStaff from 'features/HotelSetup/HotelStaff'
import HotelSetupLegalInfo from 'features/HotelSetup/LegalInfo'
import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import hotelSetupApi from 'services/api/hotelSetup'

export const hotelSetupSteps = {
  Addendum: 'Addendum',
  HotelStaff: 'HotelStaff',
  LegalInformation: 'LegalInformation',
  Payment: 'Payment'
}

const HotelSetup = () => {
  const [currentStep, setCurrentStep] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [isSetupCompleted, setIsSetupCompleted] = useState(false)

  const currentSubsidiaryId = useSelector(selectCurrentHotelId)

  const getData = useCallback(() => {
    setIsLoading(true)

    hotelSetupApi
      .steps({})
      .then(res => {
        const hotel = res.lastSteps.find(s => s.subsidiaryId === currentSubsidiaryId)

        const lastStep = hotel.activeStepKind
        const isCompleted = hotel.isCompleted

        setCurrentStep(lastStep)
        setIsSetupCompleted(isCompleted)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [currentSubsidiaryId])

  useEffect(() => {
    getData()
  }, [getData])

  function handleStepComplete() {
    getData()
  }

  if (isLoading) {
    return <LoadingIndicator />
  }

  if (!currentStep) {
    return null
  }

  if (isSetupCompleted) {
    return (
      <>
        <HotelSetupHeader step={currentStep} isSetupCompleted={isSetupCompleted} />
        <HotelSetupFinalize />
      </>
    )
  }

  return (
    <>
      <HotelSetupHeader step={currentStep} isSetupCompleted={isSetupCompleted} />
      {currentStep === hotelSetupSteps.Addendum && (
        <HotelSetupAddendum onStepComplete={handleStepComplete} />
      )}
      {currentStep === hotelSetupSteps.HotelStaff && (
        <HotelSetupHotelStaff onStepComplete={handleStepComplete} />
      )}
      {currentStep === hotelSetupSteps.LegalInformation && (
        <HotelSetupLegalInfo onStepComplete={handleStepComplete} />
      )}
    </>
  )
}

export default HotelSetup
